/**
 * Provides the shared accessible action primitive for case operations.
 */

import type { ButtonHTMLAttributes, PropsWithChildren } from "react";

interface ActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly tone?: "primary" | "secondary" | "danger";
}

const ClassByTone = Object.freeze({
  danger: "bg-[var(--color-status-critical)] text-white hover:brightness-95",
  primary: "bg-[var(--color-brand-primary)] text-white hover:brightness-95",
  secondary:
    "border border-[var(--color-border-default)] bg-white text-[var(--color-brand-deep)] hover:bg-[var(--color-surface-subtle)]",
});

/**
 * Renders a button with consistent disabled and focus behavior.
 */
export function ActionButton({
  children,
  className,
  tone = "primary",
  type = "button",
  ...properties
}: PropsWithChildren<ActionButtonProps>) {
  return (
    <button
      className={`rounded-[var(--radius-small)] px-4 py-2 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50 ${ClassByTone[tone]} ${className ?? ""}`}
      type={type}
      {...properties}
    >
      {children}
    </button>
  );
}
